import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { modules } from '../../modules';
import { SocialAccessRouter } from '../../../social-access/types';

@injectable()
export class SocialAccessRouterService implements SocialAccessRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToCreate() {
    this.history.push(
      `/${this.role.get()}/${modules.social_access.basename}/create`,
    );
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.social_access.basename}`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.social_access.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
